import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  ReactNode,
} from 'react';

interface NavigationContextType {
  navigationOpen: boolean;
  setNavigationOpen: (open: boolean) => void;
  closeNavigation: () => void;
  openNavigation: () => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

interface NavigationProviderProps {
  children: ReactNode;
}

export const NavigationProvider: React.FC<NavigationProviderProps> = ({ children }) => {
  const [navigationOpen, setNavigationOpen] = useState(true);

  const closeNavigation = useCallback(() => setNavigationOpen(false), []);
  const openNavigation = useCallback(() => setNavigationOpen(true), []);

  const value: NavigationContextType = {
    navigationOpen,
    setNavigationOpen,
    closeNavigation,
    openNavigation,
  };

  return (
    <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>
  );
};

export const useNavigation = (): NavigationContextType => {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};
